// interface MessageProps {
//   message: ReactNode;
// }

export let SignupFields;
(function (SignupFields) {
  SignupFields["phoneNumber"] = "phoneNumber";
})(SignupFields || (SignupFields = {}));